import * as React from 'react';



export default class Emptyowner extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="169" viewBox="0 0 160 169">
        <defs>
        <linearGradient id="owner__a" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#E6E8EA"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="owner__b" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="owner__c" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="owner__e" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#E6E8EA"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="owner__f" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="owner__i" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E6E8E9"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="owner__j" x1="50%" x2="50%" y1="0%" y2="106.232%">
            <stop offset="0%" stopColor="#42ABEF" stopOpacity=".357"/>
            <stop offset="100%" stopColor="#F6F7F8"/>
        </linearGradient>
        <linearGradient id="owner__k" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor="#ABD5EF" stopOpacity=".39"/>
            <stop offset="100%" stopColor="#F6F7F8"/>
        </linearGradient>
        <linearGradient id="owner__l" x1="50%" x2="50%" y1="0%" y2="74.191%">
            <stop offset="0%" stopColor="#EAEFF2"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <path id="owner__d" d="M3.198.575C.934 1.369-.382 3.809.153 6.222l.819 3.694 4.938 1.408 2.096-1.097c1.603-.84 2.605-2.551 2.585-4.412l-.037-3.324L5.794.623c-.438-.172-.9-.26-1.362-.26-.417.001-.833.071-1.234.212"/>
        <path id="owner__g" d="M0.212 0.328L86.245 0.328 86.245 86.361 0.212 86.361z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g>
            <path fill="url(#owner__a)" d="M42.913 83.179H72.622V104.635H42.913z" transform="translate(0 -1) translate(24.757)"/>
            <path fill="url(#owner__b)" d="M26.367 98.995c-3.693 6.305-4.929 13.751-3.469 20.91l3.483 17.085h64.613l2.317-16.715c1.028-7.417-.611-14.958-4.624-21.28-3.872-6.097-10.592-9.791-17.815-9.791H43.45c-7.029 0-13.53 3.726-17.083 9.791z" transform="translate(0 -1) translate(24.757)"/>
            <path fill="url(#owner__c)" d="M77.853 107.321l3.793-9.517 24.927 10.766c3.549 1.533 5.183 5.652 3.65 9.202-.437 1.013-1.108 1.908-1.958 2.613l-18.201 15.092-1.319-4.526 12.818-13.823c.751-.81.703-2.075-.107-2.826-.23-.214-.507-.37-.81-.457l-22.793-6.524z" transform="translate(0 -1) translate(24.757)"/>
            <g transform="translate(0 -1) translate(24.757) translate(4.951 86.48)"/>
            <path fill="#E7E9EB" d="M18.655 66.674L7.427 83.457 11.163 86.48 24.757 71.898z" transform="translate(0 -1) translate(24.757)"/>
            <g>
                <path fill="url(#owner__e)" d="M.311 30.378C.103 31.002.003 31.636 0 32.26v.052c.01 2.556 1.657 4.927 4.232 5.733.963.3 1.99.33 2.967.083l29.112-7.75-4.613-8.96L9.49 29.409c-.52.187-1.093-.082-1.28-.602-.05-.14-.069-.29-.054-.44l1.827-18.082h-4.4L.31 30.378z" transform="translate(0 -1) translate(24.757) translate(0 78.227)"/>
                <path fill="url(#owner__f)" d="M3.817 7.104l1.47 4.273 4.432 1.18 2.627-.96c1.742-.942 2.83-2.861 2.808-4.949-.024-2.26-1.403-4.283-3.497-5.132L9.945.82c-.477-.193-.978-.29-1.48-.29-.453 0-.905.079-1.34.236-2.46.892-3.89 3.63-3.308 6.337z" transform="translate(0 -1) translate(24.757) translate(0 78.227)"/>
            </g>
            <g transform="translate(0 -1) translate(24.757) translate(14.03 .654)">
                <mask id="owner__h" fill="#fff">
                    <use xlinkHref="#owner__g"/>
                </mask>
                <path fill="#EDEEEF" d="M86.245 43.344c0 23.758-19.259 43.017-43.016 43.017C19.47 86.36.212 67.1.212 43.344S19.47.328 43.229.328c23.757 0 43.016 19.259 43.016 43.016" mask="url(#owner__h)"/>
            </g>
            <path fill="url(#owner__i)" d="M99.03 35.315c2.734 0 4.95 2.216 4.95 4.951v6.602c0 2.735-2.216 4.951-4.95 4.951V35.315z" transform="translate(0 -1) translate(24.757)"/>
            <path fill="url(#owner__i)" d="M10.728 35.315c2.735 0 4.952 2.216 4.952 4.951v6.602c0 2.735-2.217 4.951-4.952 4.951V35.315z" transform="translate(0 -1) translate(24.757) rotate(180 13.204 43.567)"/>
            <path fill="url(#owner__j)" d="M36.426 63.544c20.644 0 32.654-10.66 34.025-28.294C71.823 17.617 57.07 0 36.426 0S-4.95 11.211 1.183 35.25s12.38 28.294 35.243 28.294z" transform="translate(0 -1) translate(24.757) translate(23.107 16.334)"/>
            <g>
                <path fill="#E7E9EB" d="M48.295 24.373c0 13.374-10.747 24.215-24.004 24.215C11.035 48.588.29 37.748.29 24.373.289 10.999 11.035.157 24.29.157 37.548.157 48.295 11 48.295 24.373" transform="translate(0 -1) translate(24.757) translate(11.553 27.887)"/>
                <path fill="url(#owner__k)" d="M24.292 44.778c-11.171 0-20.227-9.136-20.227-20.405 0-11.27 9.056-20.405 20.227-20.405 11.17 0 20.226 9.135 20.226 20.405 0 11.27-9.056 20.405-20.226 20.405z" transform="translate(0 -1) translate(24.757) translate(11.553 27.887)"/>
            </g>
            <path fill="#FFF" d="M22.882 46.985c.867-1.47 2.083-2.806 3.617-3.727.766-.457 1.592-.824 2.457-1.053.867-.217 1.756-.318 2.63-.28 1.748.101 3.403.675 4.725 1.726-1.674.15-3.165.277-4.54.608-.685.178-1.336.383-1.964.637-.308.14-.621.261-.916.427-.154.068-.301.15-.449.234-.147.082-.296.162-.437.258-1.164.694-2.248 1.594-3.313 2.61-1.073 1.022-2.099 2.156-3.236 3.394.004-1.717.578-3.352 1.426-4.834z" opacity=".45" transform="translate(0 -1) translate(24.757)"/>
        </g>
        <path fill="url(#owner__l)" d="M159.272 169.83c0-22.334-35.654-40.438-79.636-40.438C35.654 129.392 0 147.496 0 169.83" transform="translate(0 -1)"/>
    </g>
        </svg>
    )
  }
}
